
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/dentist",
      function () {
        return require("private-next-pages/[lng]/dentist.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/dentist"])
      });
    }
  